import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { MicrosoftOutlookEmailMessagesSearchInput } from "@cohesive/api-entities";
import { useInfiniteQuery } from "@tanstack/react-query";

export function useOutlookEmailMessagesList(
  connection: IntegrationConnection,
  input: MicrosoftOutlookEmailMessagesSearchInput,
) {
  return useInfiniteQuery({
    queryKey: ["outlook-email-messages-list", connection.id, input],
    queryFn: ({ pageParam }) => {
      return orgAPI.toolbox.execute({
        integration_connection_id: connection.id,
        action_name: "microsoft-outlook-email-messages-search",
        action_input: {
          ...input,
          ...(pageParam as { offset?: number }),
        },
        // Typed entities drive the rich row UI; their generic projections ride
        // along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.pagination?.has_more) {
        return lastPage.pagination.next;
      }
      return undefined;
    },
    initialPageParam: {},
  });
}
